import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';

interface VoiceSettingRanges {
  min: number,
  max: number
}
@Component({
  selector: 'app-eleven-labs-voice-settings',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSliderModule,
  ],
  templateUrl: './eleven-labs-voice-settings.component.html',
  styleUrl: './eleven-labs-voice-settings.component.scss'
})
export class ElevenLabsVoiceSettingsComponent {
  @Input() assistantForm!: FormGroup;
  voiceSpeedRange: VoiceSettingRanges = { max: 1.2, min: 0.7 };
  voiceStabilityRange: VoiceSettingRanges = { max: 1.0, min: 0.0 };
  voiceSimilarityRange: VoiceSettingRanges = { max: 1.0, min: 0.0 };
}
